document.addEventListener('DOMContentLoaded', () => {
    console.log('%c[events.js]', 'color: #5fb8ff');
    
    document.querySelectorAll('input[type="radio"][data-product-option]').forEach(el => {
        el.addEventListener('change', () => {
            document.dispatchEvent(new CustomEvent('option:changed', {
                detail: { el }
            }));
        });
    });
    
    document.querySelectorAll('variant-selects, variant-radios').forEach(el => {
        el.addEventListener('change', (e) => {
            const variant = el.currentVariant;
            if (variant) {
                document.dispatchEvent(new CustomEvent('variant:changed', {
                    detail: { variant }
                }));
            }
        });
    });

    document.addEventListener('variant:changed', function (e) {
        const variant = e.detail.variant;
        
        updatePriceContainer(variant);
    });
    
    document.addEventListener('option:changed', function (e) {
        const option = e.detail;
        sfUupdateMedia(option.el.value,option.el.dataset.sectionId);
        
        const nextOptionId = 'SingleOptionSelector-' + option.el.dataset.nextOption;
        const nextOption = document.getElementById(nextOptionId);
        if(nextOption) {
            
            const y = nextOption.getBoundingClientRect().top + window.scrollY; // element's Y relative to page

            window.scrollTo({
              top: y - 100,   // leave 100px gap above
              behavior: "smooth"
            });
            
        }
    });

    function updatePriceContainer(variant) {
        const priceContainer = document.querySelector('.price--product_external');
        if (!priceContainer) return;

        const formattedPrice = formatPrice(variant.price);
        const formattedCompareAtPrice = variant.compare_at_price ? formatPrice(variant.compare_at_price) : null;

        let priceHTML = '';

        if (formattedCompareAtPrice && variant.compare_at_price > variant.price) {
            // Sale price
            priceHTML = `
                <div class="price__sale">
                    <span class="price-item price-item--sale">${formattedPrice}</span>
                    <s class="price-item price-item--regular">${formattedCompareAtPrice}</s>
                </div>
            `;
        } else {
            // Regular price
            priceHTML = `
                <div class="price__regular">
                    <span class="price-item price-item--regular">${formattedPrice}</span>
                </div>
            `;
        }

        priceContainer.innerHTML = priceHTML;
    }

    function formatPrice(price) {
        return new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP'
        }).format(price / 100); // Shopify prices are typically in cents/pence
    }
    
    function sfUupdateMedia(optionValue,sectionId) {
		let mediaList = document.querySelector(".product__media-list");
        console.log('Media list: ',mediaList);
        
        let optionIndex = -1;
        window.sfProduct.options.forEach((option, key) => {
            if(option == 'Cable Type') {
                optionIndex = key;
            }
        });
        let mediaId = 0;
        if(optionIndex >= 0) {
            window.sfProduct.variants.forEach(variant => {
                if(variant.options[optionIndex] == optionValue) {
                    mediaId = variant.featured_media.id;
                }
            });
        }
		const activeMedia = mediaList.querySelector(
			`[data-media-id="${mediaId}"]`,
		);
		mediaList.querySelectorAll("[data-media-id]").forEach((element) => {
			element.classList.remove("active");
		});
		if (activeMedia) activeMedia.classList.add("active");

		const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

		swiperWrappers.forEach((elem) => {
            const newMedia = elem.querySelector(
                `[data-media-id="${sectionId}-${mediaId}"]`,
            );

            if (elem.querySelector(".js-media-list")) {
                elem
                    .querySelector(".js-media-list")
                    .swiper.slideTo(
                        elem
                            .querySelector(".js-media-list")
                            .swiper.slides.indexOf(newMedia),
                    );
            }
		});
	}
});